<template>
  <div class="accent--text">
    <v-row>
      <v-col md="3"><h3>Booking number</h3></v-col>
      <v-col><h3>{{ booking.orderNumber.number }}</h3></v-col>
    </v-row>
    <v-row>
      <v-col>
        <h2 class="main--text"> Disposing </h2>
      </v-col>
    </v-row>
    <v-row class="mt-4">
      <v-col md="3">
        <h3>Date</h3>
      </v-col>
      <v-col md="3">
        <h3>{{ booking.preferredDate + " " +(booking.preferredTime == 'AM' ? 'in the morning' : 'in the afternoon')}} </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3">
        <h3> Customer </h3>
      </v-col>
      <v-col>
        <h3> {{ booking.customer.companyName ? booking.customer.companyName : booking.customer.firstName +' '+ booking.customer.lastName }} </h3>
      </v-col>
    </v-row>
    <v-row class="mt-4">
      <v-col md="3">
        <h3>Waste type</h3>
      </v-col>
      <v-col md="3">
        <h3>{{ booking.waste.name }}</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3">
        <h3>Vehicle type</h3>
      </v-col>
      <v-col md="3">
        <h3>{{ booking.vehicle.name }}</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p class="pt-1 par1"><span class="main--text" style="font-size: 60px; font-weight: bold;">.</span> Upload image of the waste after disposing it at landfill</p>
         <p class="par2"><span class="main--text" style="font-size: 60px; font-weight: bold;">.</span> Enter the receipt number in the field provided below. </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h2 class="primary--text">Upload waste picture:</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
      
        <image-uploader
          capture="camera"
          accept="image/*"
          :maxWidth="100"
          :quality="0.2"
          :preview="true"
          :className="['fileinput', { 'fileinput--loaded': hasImage }]"
          :debug="1"
          doNotResize="gif"
          :autoRotate="true"
          outputFormat="verbose"
          @input="setImage"
        >
          <label for="fileInput" slot="upload-label">
            <span class="upload-caption">{{
              hasImage ? "Replace" : "Click to upload"
            }}</span>
          </label>
        </image-uploader>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="4">
         <v-text-field 
         v-model="receiptNumber" 
         outlined 
         dense
         label="Enter receipt number #"
         > </v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="image!=null && this.receiptNumber.length>2">
      <v-col>
        <v-btn class="primary" v-on:click="changeStatus"> Dispose </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'DriverDisposed',
  props: { 
    booking: Object
  },
  data (){
    return {
      imageData: null,
      picture: null,
      uploadValue: 0,
      receiptNumber: '',
      hasImage: false,
      image: null
    }
  },
  methods:{
    setImage(output) {
      this.hasImage = true;
      this.image = output.dataUrl;

    },
    async changeStatus() {
      await this.$store.dispatch('uploadImage', this.receiptNumber, this.image);
      this.$store.dispatch('updateBooking', {
        id: this.booking.id,
        receiptNumber: this.receiptNumber,
        status: {
          ...this.booking.status,
          status: 'DISPOSED'
        }
      });
    }

  }
}
</script>

<style scoped>
.preview {
    width: 100%;
}
.par1{
  position: relative;
  top: -0.2cm;
}
.par2{
  position: relative;
  top: -1cm;
  margin-bottom: -1cm;
}
</style>